<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["data", "options", "refresh"],
  data() {
    return {
      defaultData: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
        ],
        datasets: [
          {
            label: "Order Value",
            //new option, type will default to bar as that what is used to create the scale
            type: "line",
            data: [10000, 10000, 10000, 10000, 10000, 10000, 10000],
            fill: false,
            borderColor: '#ffffff'
          },
          {
            label: "Accumulated Spend",
            //new option, type will default to bar as that what is used to create the scale
            type: "bar",
            data: [3200, 5000, 7000, 8800, 9000, 9200, 10300],
            backgroundColor: ["#007bff", "#28a745", "#ffc107", "#dc3545", "#007bff", "#28a745", "#ffc107"],
          },
        ],
      },
      defaultOptions: {
        responsive: true,
        maintainAspectRatio: true,
        title: {
          display: true,
          text: "Demo Data",
        },
        legend: {
          display: false,
          position: "bottom",
          labels: {
            boxWidth: 10,
            display: true,
            fontSize: 10,
          },
        },
        onClick: function (evt, item) {
          var activePoints = this.getElementsAtEvent(evt);
          var firstPoint = activePoints[0];
          console.log("bar click", evt, item, activePoints, firstPoint);
        },
      },
      chartData: null,
      chartOptions: null,
    };
  },
  mounted() {
    this.render();
  },
  watch: {
    data: {
      // immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.render();
        }
      },
    },
  },
  methods: {
    async render() {
      if (this.data) {
        this.chartData = this.data;
      } else {
        this.chartData = this.defaultData;
      }
      if (this.options) {
        this.chartOptions = this.options;
      } else {
        this.chartOptions = this.defaultOptions;
      }

      this.renderChart(this.chartData, this.chartOptions);
    },
  },
};
</script>